import { read, utils } from 'xlsx';


export async function xlsxFileToTable(
    file: File,
): Promise<string[][]> {
    const arrayBuffer = await file.arrayBuffer();
    const workbook = read(arrayBuffer, { type: 'array', cellFormula: false });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];

    // Normalize the sheet range to start at A1 so leading empty rows/columns are preserved.
    // Keep the original end cell from the parsed sheet ref.
    const sheetRef = worksheet['!ref'] ?? 'A1:A1';
    const decodedRange = utils.decode_range(sheetRef);
    const fullRangeRef = utils.encode_range({ s: { r: 0, c: 0 }, e: decodedRange.e });

    const rows = utils.sheet_to_json<unknown[]>(worksheet, {
        header: 1,
        range: fullRangeRef,
        blankrows: true,
        defval: '',// fill empty cells so matrix shape is stable
    });

    const result = rows.map(row => row.map(cell => String(cell ?? '')));
    return result;
}
